import React from 'react';
import { Button } from '@lightspeed/flame/Button';
import Text from '@lightspeed/cirrus-text';

const defaultClick = () => {};
const Header = ({ isSubmitting, isDisabled, onInstallClick = defaultClick }) => (
  <div className="cr-flex cr-justify-between cr-mb-4">
    <div>
      <Text body bold>
        Take your business online today!
      </Text>
      <Text body>Simply review the information below and install your eCom store.</Text>
    </div>
    <Button
      onClick={onInstallClick}
      variant="primary"
      fill
      size="large"
      disabled={isDisabled}
      loading={isSubmitting}
      data-test="install-button"
    >
      Install My eCom Store
    </Button>
  </div>
);

export default Header;
